// AI Generated Component
import { Component, Input } from '@angular/core';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { StateService } from '@uirouter/core';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

@Component({
    selector: 'label-blocked-by-domain-groups',
    standalone: false,
    template: `
        <form name="form" class="form-horizontal" (ngSubmit)="form.valid && submit()">
            <div class="mon-dialog-header">
                <page-header [header]="'Can\\'t delete label' | translate"></page-header>
            </div>
            <div class="mon-dialog-body-with-footer bg-white">
                <div class="card-body">
                    <mon-label-blocked-by-domain-groups
                        [monLabel]="label"
                        [monDomains]="domains">
                    </mon-label-blocked-by-domain-groups>
                </div>
            </div>
            <div class="mon-dialog-footer text-right">
                <button data-test="close-button"
                        class="btn btn-border-radius btn-secondary mr-2"
                        type="button"
                        (click)="close()">
                    <span translate>Cancel</span>
                </button>
                <button data-test="open-domain-settings-button"
                        class="btn btn-border-radius btn-secondary"
                        type="button"
                        (click)="openDomainsSettings()">
                    <span translate>Domain Settings</span>
                </button>
            </div>
        </form>
    `,
})
export class LabelBlockedByDomainGroupsComponent {
    @Input() label: any;
    @Input() domains: any;
    @Input() monDialogId?: string;

    form = { valid: true };

    constructor (
        private monDialog: MonDialog,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    submit (): void {
        // Implementation if needed
    }

    close (): void {
        this.monDialog.close(this.monDialogId, null);
    }

    openDomainsSettings (): void {
        this.monUIRouterTransitionService.onTransitionFinished(() => {
            this.close();
            this.stateService.go('base.customer.admin.domains.index');
        });
    }
}
